import InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';
import { changeSignInState } from '../actions/presenceActions';
import ChatSignInState from '../store/schema/ChatSignInState';

export default function onSignOn(notification: InstantMessagePayload) {
    if (notification.SignOnStarted) {
        return;
    }

    changeSignInState(ChatSignInState.SignedIn);
}
